import { doc, onSnapshot, setDoc } from 'firebase/firestore';
import { db } from './firebase';

const LOCAL_INVENTORY_KEY = 'gearnode_inventory_v2';
const LEGACY_INVENTORY_KEY = 'gearnode_inventory';

const inventoryRef = uid =>
  doc(db, 'artifacts', 'gearnode-prod-v1', 'users', uid, 'settings', 'inventory');

const CODE_ALPHABET = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';

export function generateInventoryCode(random = Math.random) {
  const token = Array.from({ length: 6 }, () => CODE_ALPHABET[Math.floor(random() * CODE_ALPHABET.length)]).join('');
  return `GN-${token.slice(0, 3)}-${token.slice(3)}`;
}

export function createAsset(deviceId, sequence = 0) {
  const assetId = typeof crypto !== 'undefined' && crypto.randomUUID
    ? crypto.randomUUID()
    : `${deviceId}-${Date.now()}-${sequence}-${Math.random().toString(36).slice(2, 7)}`;
  return { assetId, deviceId, inventoryCode: generateInventoryCode(), label: '', serialNumber: '', purchaseDate: '', notes: '', status: 'available' };
}

export function migrateInventory(items = []) {
  const usedCodes = new Set();
  return items.flatMap((item, index) => {
    if (item.assetId) {
      const inventoryCode = item.inventoryCode && !usedCodes.has(item.inventoryCode) ? item.inventoryCode : generateInventoryCode();
      usedCodes.add(inventoryCode);
      return [{ status: 'available', label: '', ...item, inventoryCode }];
    }
    const quantity = Math.max(1, Number(item.quantity) || 1);
    return Array.from({ length: quantity }, (_, copyIndex) => ({
      ...createAsset(item.deviceId, copyIndex),
      assetId: `legacy-${item.deviceId}-${index}-${copyIndex}`,
      serialNumber: copyIndex === 0 ? (item.serialNumber || '') : '',
      purchaseDate: item.purchaseDate || '',
      notes: item.notes || '',
    }));
  });
}

export function loadInventory(fallback = []) {
  try {
    const current = JSON.parse(localStorage.getItem(LOCAL_INVENTORY_KEY));
    if (Array.isArray(current)) return migrateInventory(current);
    const legacy = JSON.parse(localStorage.getItem(LEGACY_INVENTORY_KEY));
    if (Array.isArray(legacy) && legacy.length) return migrateInventory(legacy);
  } catch {}
  return migrateInventory(fallback);
}

export async function saveInventory(user, assets) {
  localStorage.setItem(LOCAL_INVENTORY_KEY, JSON.stringify(assets));
  if (!user || user.isAnonymous) return;
  await setDoc(inventoryRef(user.uid), { assets, updatedAt: Date.now(), schemaVersion: 2 }, { merge: true });
}

export function subscribeInventory(user, onData, onError) {
  if (!user || user.isAnonymous) return () => {};
  return onSnapshot(inventoryRef(user.uid), snapshot => {
    if (snapshot.exists() && Array.isArray(snapshot.data().assets)) onData(migrateInventory(snapshot.data().assets));
  }, onError);
}
